import { Activity, Building2, ClipboardList, Clock, FileInput, FileCheck2, FileClock, FileSearch, FileWarning, FileX2, CircleAlert, TriangleAlert, GitBranch, Mail, MessageSquare, Plug, Rocket, UserCheck, UserRound, Users, Workflow, Zap } from "lucide-react";
import { getEventTypeInfo, type EventType } from "@packages/commons";

const eventCategoryIcons = {
  release: Rocket, feedback: MessageSquare, contact: Users, session: Workflow,
  orgmodels: Building2, task: ClipboardList, integration: Plug, assignment: UserCheck,
  communication: Mail, usage: Activity, expiration: Clock, trigger: Zap,
  job: GitBranch, fileProcessing: FileInput, user: UserRound,
};
const eventTypeIcons = {
  "fileProcessing.call": FileSearch,
  "fileProcessing.started": FileClock,
  "fileProcessing.succeeded": FileCheck2,
  "fileProcessing.failedRows": FileWarning,
  "fileProcessing.failed": FileX2,
  "session.error": CircleAlert,
  "session.raiseWarning": TriangleAlert,
  "session.raiseError": CircleAlert,
} as Partial<Record<EventType, typeof FileInput>>;

export const EventIcon = ({ eventType, className, size = 20 }: { eventType?: string; className?: string; size?: number }) => {
  const info = getEventTypeInfo(eventType);
  const Icon = info ? eventTypeIcons[info.id] || eventCategoryIcons[info.category] : Activity;
  return <Icon size={size} className={className} aria-hidden="true" />;
};
